import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error("ErrorBoundary caught an error:", error);
    console.error("Error info:", errorInfo);

    // Store error info in state for display
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div role="alert" className="min-h-screen flex items-center justify-center bg-black text-white flex-col px-4">
          <h2 className="text-2xl font-bold text-accent mb-4">Terjadi Kesalahan</h2>
          <p className="text-gray-400 mb-6 text-center max-w-md">
            Maaf, terjadi kesalahan tak terduga. Silakan muat ulang halaman atau hubungi support jika masalah berlanjut.
          </p>
          {import.meta.env.DEV && error && (
            <details className="mb-6 max-w-2xl w-full bg-gray-900 p-4 rounded-lg">
              <summary className="cursor-pointer text-accent mb-2">Detail Error (Development Only)</summary>
              <pre className="text-xs text-red-400 overflow-auto">
                {error.toString()}
              </pre>
            </details>
          )}
          <button
            onClick={this.handleReset}
            className="px-6 py-3 bg-accent text-black font-bold rounded-full hover:bg-white transition-colors"
          >
            Muat Ulang Halaman
          </button>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
